export default "__VITE_ASSET__4a7f647e__"